import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

export default function AuthCallback() {
  const navigate = useNavigate();
  const { loginWithGoogle } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate('/');
      return;
    }

    const sessionId = match[1];

    loginWithGoogle(sessionId)
      .then(user => {
        // Navigate to the appropriate dashboard based on role
        if (user.role === 'admin') {
          navigate('/admin', { replace: true });
        } else if (user.role === 'vendor') {
          navigate('/vendor', { replace: true });
        } else {
          navigate('/', { replace: true });
        }
      })
      .catch(err => {
        const detail = err.message || 'Google login failed';
        // Navigate to appropriate login page with error
        if (detail.includes('No account found')) {
          navigate('/vendor/login', { replace: true, state: { googleError: detail } });
        } else {
          navigate('/admin/login', { replace: true, state: { googleError: detail } });
        }
      });
  }, [loginWithGoogle, navigate]);

  return (
    <div className="min-h-screen bg-[#0a0a0a] flex items-center justify-center">
      <div className="text-center">
        <div className="w-8 h-8 border-2 border-[#D4A843] border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-white/50 text-sm" style={{ fontFamily: 'Manrope, sans-serif' }}>Signing in with Google...</p>
      </div>
    </div>
  );
}
